import URIS from 'constants/uris';
import http from 'services/http';

export function createUser(params) {
  return http.post(URIS.CREATE_USER, params);
}
